export default "__VITE_ASSET__71f0fdfd__"